import classNames from 'classnames';

type ErrorMessageProps = {
  className?: string;
  textClassName?: string;
  children?: React.ReactNode;
};

export default function ErrorMessage({
  className,
  textClassName,
  children,
}: ErrorMessageProps) {
  if (!children) {
    return null;
  }

  return (
    <span
      className={classNames(
        'flex items-center text-small-caption text-red-100',
        className,
      )}
    >
      <span className={classNames('text-left', textClassName)}>{children}</span>
    </span>
  );
}
